import {clientService} from '../network/services/client.service';
import {ResponseError} from "../network/response/response-error";

class CardStructure {
  constructor(cardData) {
    this.cardData = cardData;
  }

  getBrand() {
    return this.cardData.card.brand;
  }

  getBrandIconClass() {
    if (this.getBrand() === 'mastercard') {
      return 'lab la-cc-mastercard';
    }
    if (this.getBrand() === 'visa') {
      return 'lab la-cc-visa';
    }
    if (this.getBrand() === 'amex') {
      return 'lab la-cc-amex';
    }
    return 'las la-credit-card';
  }

  isMain() {
    return this.cardData.is_default;
  }

  getLast4() {
    return this.cardData.card.last4;
  }

  getCountry() {
    return 'FR';
  }

  getExpiration() {
    return `${this.cardData.card.exp_month}/${this.cardData.card.exp_year.toString().slice(-2)}`;
  }

  getId() {
    return this.cardData.id;
  }

  getHolderName() {
    return this.cardData.billing_details.name;
  }
}

export default {
  namespaced: true,
  state: {
    loading: false,
    cards: [],
  },
  mutations: {
    SET_CARDS(state, payload) {
      state.cards = payload.map(p => new CardStructure(p));
    },
    SET_LOADING(state, payload) {
      state.loading = !!payload;
    },
  },
  actions: {
    async fetch(context) {
      context.commit('SET_LOADING', true);
      const response = await clientService.fetchCards(context.rootState.client.tokens.accessToken);
      const sources = response.get('Auth.sources', []);
      if (sources instanceof ResponseError) {
        // TODO catch errors
      } else {
        context.commit('SET_CARDS', sources);
      }
      context.commit('SET_LOADING', false);
    },
    async createSetupIntent(context) {
      const response = await clientService.createSetupIntent(context.rootState.client.tokens.accessToken);
      const setup = response.get('Auth.sources.createSetupIntent.client_secret', null);
      if (setup instanceof ResponseError) {
        // TODO catch errors
      }
      return setup;
    },
    async attach(context, paymentMethodToken) {
      const response = await clientService.attachSetupIntent(context.rootState.client.tokens.accessToken, paymentMethodToken);
      const result = response.get('Auth.sources.attachPaymentMethod.attached', false);
      if (result instanceof ResponseError) {
        // TODO catch errors
      } else if (result === false) {
        // TODO catch errors
      }
    },
    async deleteCard(context, cardId) {
      context.commit('SET_LOADING', true);
      const response = await clientService.deleteCard(context.rootState.client.tokens.accessToken, cardId);
      const deleted = response.get('Auth.sources.deleteCard.deleted', false);
      if (deleted instanceof ResponseError) {
        // TODO catch errors
      } else if (deleted === false) {
        //TODO catch errors
      } else {
        context.dispatch('stripeCard/fetch', null, {root: true});
      }
    },
    async setMain(context, cardId) {
      context.commit('SET_LOADING', true);
      const response = await clientService.setMain(context.rootState.client.tokens.accessToken, cardId);
      const result = response.get('Auth.sources.setMain.updated', false);
      if (result instanceof ResponseError) {
        // TODO catch errors
      } else if (result === false) {
        // TODO catch errors
      } else {
        context.dispatch('stripeCard/fetch', null, {root: true});
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/stripe-card.store.js